const decodePathSegment = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

/** Strips protocol/host and leading slashes so paths are comparable across URL and relative forms. */
export const normalizePdfPath = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) return "";

  let path = trimmed;

  try {
    if (/^https?:\/\//i.test(trimmed)) {
      const url = new URL(trimmed);
      path = url.pathname;
    }
  } catch {
    // Fall through to plain path normalization.
  }

  return decodePathSegment(path.replace(/^\/+/, ""));
};

export const getPdfPathBasename = (value: string): string => {
  const normalized = normalizePdfPath(value);
  if (!normalized) return "";
  const parts = normalized.split("/");
  return decodePathSegment(parts[parts.length - 1] ?? normalized);
};
